import { render, staticRenderFns } from "./BulkSendModal.vue?vue&type=template&id=15a24547&"
import script from "./BulkSendModal.vue?vue&type=script&lang=js&"
export * from "./BulkSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports